import type React from 'react';
import { forwardRef } from 'react';
import TextArea, { type TextAreaProps } from '../forms/TextArea';

export interface TextBoxProps extends Omit<TextAreaProps, 'label'> {
  label?: string;
}

const CHATBOX_NAME = 'ChatBox';

const ChatBox = forwardRef<HTMLTextAreaElement, TextBoxProps>(({ ...props }, ref) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // allow new line in text area if "Shift" + "Enter"
        return;
      } else {
        e.preventDefault();
        //@ts-expect-error
        props.onSubmit?.(e);
      }
    }
  };

  return <TextArea {...props} label="" ref={ref} rows={1} onKeyDown={onKeyDown} autoFocus growWithContent={true} />;
});

ChatBox.displayName = CHATBOX_NAME;
export default ChatBox;
